import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { MoonIcon, SunIcon } from './Icons';

interface HeaderProps {
  darkMode: boolean;
  toggleDarkMode: () => void;
}

const Header: React.FC<HeaderProps> = ({ darkMode, toggleDarkMode }) => {
  const location = useLocation();
  const isPrivacyPage = location.pathname.includes('/privacy-policy');

  const scrollToSection = (sectionId: string) => {
    if (isPrivacyPage) return; // Don't scroll on privacy page
    
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header className="header">
      <div className="container">
        <div className="header-content">
          {/* Logo */}
          <div>
            <Link to="/" className="logo" style={{ textDecoration: 'none' }}>
              RapidNova
            </Link>
          </div>

          {/* Navigation */}
          {!isPrivacyPage && (
            <nav className="nav">
              <button 
                onClick={() => scrollToSection('hero')} 
                className="nav-link" 
                style={{ 
                  background: 'none', 
                  border: 'none', 
                  cursor: 'pointer',
                  fontSize: '0.95rem',
                  fontFamily: 'inherit'
                }}
              >
                Home
              </button>
              <button 
                onClick={() => scrollToSection('about')} 
                className="nav-link"
                style={{ 
                  background: 'none', 
                  border: 'none', 
                  cursor: 'pointer',
                  fontSize: '0.95rem',
                  fontFamily: 'inherit'
                }}
              >
                About
              </button>
              <button 
                onClick={() => scrollToSection('contact')} 
                className="nav-link"
                style={{ 
                  background: 'none', 
                  border: 'none', 
                  cursor: 'pointer',
                  fontSize: '0.95rem',
                  fontFamily: 'inherit'
                }}
              >
                Contact
              </button>
            </nav>
          )}

          {/* Dark mode toggle */}
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <button
              onClick={toggleDarkMode}
              className="dark-toggle"
              aria-label="Toggle dark mode"
            >
              {darkMode ? <SunIcon /> : <MoonIcon />}
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header; 